import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const SectionAllStudentList = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")

    const initialFormState = {
        sectionMasterId: sectionMasterId,
        instituteMasterId: instituteMasterId,
        year: '',
        gradeId: '',
        divisionId: '',
    }

    const [gradeList, setGradeList] = useState([])
    const [divisionList, setDivisionList] = useState([])
    const [yearList, setYearList] = useState([])
    const [importStudentData, setImportStudentData] = useState(initialFormState)
    const [importStudentList, setImportStudentList] = useState([])
    const [isAllActive, setIsAllActive] = useState(false);

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [studentIdSort, setStudentIdSort] = useState(null);
    const [regIdSort, setRegIdSort] = useState(null);
    const [nameSort, setNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["std_id", "regis_no", "studentName", "primaryContact", "email"];


    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getGradeList()
        getYearList()
    }, []);

    useEffect(() => {
        getImportStudentList();
    }, [importStudentData]);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getImportStudentList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (importStudentData.year !== '') {
                const data = await searchArray("B", getApiUrl(), searchKeys, searchValue.trim(), "rows")
                setImportStudentList(data);
                setIsAllActive(checkAllActive(data));
            }
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(importStudentList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(importStudentList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > importStudentList.length) {
            endIndex = importStudentList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(importStudentList.slice(startIndex, endIndex));
    }, [importStudentList, currPage, itemsPerPage]);

    const getImportStudentList = async () => {
        if (importStudentData.year !== '') {
            try {
                const response = await authorizedAxiosSection.get(getApiUrl());
                setImportStudentList(response.data.result.rows);
                setIsAllActive(checkAllActive(response.data.result.rows))
            } catch (error) {
                setImportStudentList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            }
        }
    }

    const getApiUrl = () => {
        let apiUrl = '/students?';
        if (importStudentData.sectionMasterId !== '') {
            apiUrl += `sectionMasterId=${importStudentData.sectionMasterId}&`;
        }
        if (importStudentData.instituteMasterId !== '') {
            apiUrl += `instituteMasterId=${importStudentData.instituteMasterId}&`;
        }
        if (importStudentData.year !== '') {
            apiUrl += `year=${importStudentData.year}&`;
        }
        if (importStudentData.gradeId !== '') {
            apiUrl += `gradeId=${importStudentData.gradeId}&`;
        }
        if (importStudentData.divisionId !== '') {
            apiUrl += `divisionId=${importStudentData.divisionId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    const getGradeList = () => {
        const apiUrlForSyllabus = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setGradeList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getYearList = () => {
        const apiUrlForSyllabus = `/active-academic-years`;
        authorizedAxios && authorizedAxios.get(apiUrlForSyllabus)
            .then(response => {
                setYearList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setImportStudentData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleGradeChange = (e) => {
        setImportStudentData((prevData) => {
            return {
                ...prevData,
                divisionId: '',
                [e.target.name]: e.target.value
            }
        })

        const apiUrlForSyllabus = `/grade-wise-division?instituteMasterId=${instituteMasterId}&instituteGradeMasterId=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSyllabus)
            .then(response => {
                setDivisionList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const changeActive = async (id, activationStatus) => {
        setLoading(true);
        const data = {
            sectionMasterId,
            instituteMasterId,
            studentId: id,
            activationStatus,
        };

        const apiUrl = `/students-activation`;

        try {
            const response = await authorizedAxiosSection.patch(apiUrl, data);
            await getImportStudentList();

            setStudentIdSort(null);
            setRegIdSort(null);
            setNameSort(null);

            setTimeout(() => {
                Swal.fire({ text: response.data.message });
            }, 100);
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire({ text: errorMsg });
        } finally {
            setLoading(false); // End loading
        }
    };

    const changeBulkActiveInactive = async (data) => {
        setLoading(true);
        const apiUrl = `/bulk-students-activation`;

        try {
            const response = await authorizedAxiosSection.patch(apiUrl, data);
            await getImportStudentList();

            setStudentIdSort(null);
            setRegIdSort(null);
            setNameSort(null);

            Swal.fire({ text: response.data.message });
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire({ text: errorMsg });
        } finally {
            setLoading(false); // End loading
        }
    };


    const checkAllActive = (data) => {
        return data.every(item => item.isActive);
    }

    const getIdsByActiveState = (data) => {
        // Check if all elements have isActive as true
        const isAllActive = data.every(item => item.isActive);

        // Check if all elements have isActive as false
        const isAllInactive = data.every(item => !item.isActive);

        // If all are active or all are inactive, return all ids
        const studentIds = isAllActive || isAllInactive
            ? data.map(item => item.id)
            : data.filter(item => !item.isActive).map(item => item.id);

        // Check the activation status of any one ID, here taking the first ID for example
        const idToCheck = studentIds[0]; // Assuming you want to check the first ID
        const studentToCheck = data.find(item => item.id === idToCheck);

        let activationStatus;
        if (studentToCheck) {
            activationStatus = studentToCheck.isActive ? 0 : 1; // 0 for active, 1 for inactive
        } else {
            activationStatus = 1; // If the ID is not found, consider it inactive (optional)
        }

        return {
            activationStatus,
            studentIds
        };
    };

    const handleInputReset = () => {
        setImportStudentData(initialFormState)
        setImportStudentList([])
        setIsAllActive(false);

        setStudentIdSort(null);
        setRegIdSort(null);
        setNameSort(null);
    }

    useEffect(() => {
        if (studentIdSort == true || studentIdSort == false) {
            setRegIdSort(null);
            setNameSort(null);
        }
    }, [studentIdSort])

    useEffect(() => {
        if (regIdSort == true || regIdSort == false) {
            setStudentIdSort(null);
            setNameSort(null);
        }
    }, [regIdSort])

    useEffect(() => {
        if (nameSort == true || nameSort == false) {
            setStudentIdSort(null);
            setRegIdSort(null);
        }
    }, [nameSort])


    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>All Student</span></li>
                        </ol>
                    </nav>
                </div>

                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-users-line"></i>All Student</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Year :</label>
                                                    <select class="form-select" aria-label="Default select example" name='year' onChange={handleInputChange} value={importStudentData.year}>
                                                        <option selected value={''} disabled>Select Year</option>
                                                        {
                                                            yearList?.map((year) => {
                                                                return <option value={year.id}>{year.yearName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <select class="form-select" aria-label="Default select example" name='gradeId' onChange={handleGradeChange} value={importStudentData.gradeId}>
                                                        <option selected value={''} disabled>Select Class :</option>
                                                        {
                                                            gradeList?.map((grade) => {
                                                                return <option value={grade.id}>{grade.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Division :</label>
                                                    <select class="form-select" aria-label="Default select example" name='divisionId' onChange={handleInputChange} value={importStudentData.divisionId}>
                                                        <option selected value={''} disabled>Select Division</option>
                                                        {
                                                            divisionList?.map((division) => {
                                                                return <option value={division.id}>{division.divisionName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        <button className="btn btn-danger delete_icon" type="button" style={{ marginRight: "20px" }} onClick={handleInputReset}>Reset</button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Std Id
                                                                            <SortIcon sortState={studentIdSort} setSortState={setStudentIdSort} setData={setImportStudentList} setCurrPage={setCurrPage} sortingPath={"std_id"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Reg Id
                                                                            <SortIcon sortState={regIdSort} setSortState={setRegIdSort} setData={setImportStudentList} setCurrPage={setCurrPage} sortingPath={"regis_no"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Name
                                                                            <SortIcon sortState={nameSort} setSortState={setNameSort} setData={setImportStudentList} setCurrPage={setCurrPage} sortingPath={"studentName"} />
                                                                        </th>
                                                                        <th scope="col">Phone No</th>
                                                                        <th scope="col">Email</th>
                                                                        <th scope='col'>
                                                                            Active/Inactive
                                                                            {importStudentList.length > 0 && <div className={`toggle-container ${isAllActive ? 'active' : ''}`} onClick={() => changeBulkActiveInactive(getIdsByActiveState(importStudentList))} >
                                                                                <div className="toggle-background"></div>
                                                                                <div className="toggle-switch"></div>
                                                                            </div>}
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData?.map((std, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{std.std_id}</td>
                                                                                        <td>{std.regis_no}</td>
                                                                                        <td>{std.studentName}</td>
                                                                                        <td>{std.primaryContact}</td>
                                                                                        <td>{std.email}</td>
                                                                                        <td>
                                                                                            <div className={`toggle-container ${std.isActive ? 'active' : ''}`} onClick={() => changeActive(std.id, !std.isActive)}>
                                                                                                <div className="toggle-background"></div>
                                                                                                <div className="toggle-switch"></div>
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Students Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={importStudentList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionAllStudentList
